module.exports = `${require.publicPath}home-img01.0411f7cf.png`;